import React from "react";
import Loadable from "react-loadable";

import DefaultLayout from "./containers/DefaultLayout";

function Loading() {
  return <div>Loading...</div>;
}

const Dashboard = Loadable({
  loader: () => import("./views/Dashboard/Dashboard"),
  loading: Loading,
});

const Members = Loadable({
  loader: () => import("./views/Sg/Members"),
  loading: Loading,
});

const Players = Loadable({
  loader: () => import("./views/Sg/Players"),
  loading: Loading,
});

const Tables = Loadable({
  loader: () => import("./views/Sg/Tables"),
  loading: Loading,
});

const Tournaments = Loadable({
  loader: () => import("./views/Sg/Tournaments"),
  loading: Loading,
});

const Categories = Loadable({
  loader: () => import("./views/Sg/Categories"),
  loading: Loading,
});

const ItemCategories = Loadable({
  loader: () => import("./views/Sg/ItemCategories"),
  loading: Loading,
});

const Items = Loadable({
  loader: () => import("./views/Sg/Items"),
  loading: Loading,
});

const Challenges = Loadable({
  loader: () => import("./views/Sg/Challenges"),
  loading: Loading,
});

const Modes = Loadable({
  loader: () => import("./views/Sg/Modes"),
  loading: Loading,
});

const ModeFamily = Loadable({
  loader: () => import("./views/Sg/ModeFamily"),
  loading: Loading,
});

const Highlight = Loadable({
  loader: () => import("./views/Sg/Highlight"),
  loading: Loading,
});

const Games = Loadable({
  loader: () => import("./views/Sg/Games"),
  loading: Loading,
});

const Budget = Loadable({
  loader: () => import("./views/Development/Budget.js"),
  loading: Loading,
});

const Role = Loadable({
  loader: () => import("./views/Development/Role"),
  loading: Loading,
});

const SkillType = Loadable({
  loader: () => import("./views/Development/SkillType"),
  loading: Loading,
});

const Developer = Loadable({
  loader: () => import("./views/Development/Developer"),
  loading: Loading,
});

const GameDeveloper = Loadable({
  loader: () => import("./views/Development/GameDeveloper"),
  loading: Loading,
});

const Templates = Loadable({
  loader: () => import("./views/Sg/Templates"),
  loading: Loading,
});

const Skills = Loadable({
  loader: () => import("./views/Development/Skills"),
  loading: Loading,
});

const Whitelist = Loadable({
  loader: () => import("./views/IdeaLaunch/Whitelist"),
  loading: Loading,
});

const Users = Loadable({
  loader: () => import("./views/IdeaLaunch/Users"),
  loading: Loading,
});

const Force = Loadable({
  loader: () => import("./views/IdeaLaunch/force"),
  loading: Loading,
});

const VariableType = Loadable({
  loader: () => import("./views/Nft/VariableType"),
  loading: Loading,
});
const VariableItems = Loadable({
  loader: () => import("./views/Nft/VariableItems"),
  loading: Loading,
});
const Weapons = Loadable({
  loader: () => import("./views/Nft/Weapons"),
  loading: Loading,
});
const Rarity = Loadable({
  loader: () => import("./views/Nft/Rarity"),
  loading: Loading,
});
const NftSkills = Loadable({
  loader: () => import("./views/Nft/HeroActions"),
  loading: Loading,
});
const NftHeros = Loadable({
  loader: () => import("./views/Nft/heros"),
  loading: Loading,
});
const NftDrop = Loadable({
  loader: () => import("./views/Nft/drop"),
  loading: Loading,
});
const NftHerosBatch = Loadable({
  loader: () => import("./views/Nft/heros_batch"),
  loading: Loading,
});

const Result = Loadable({
  loader: () => import("./views/Sg/Event/Result"),
  loading: Loading,
});

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  { path: "/", exact: true, name: "Home", component: DefaultLayout },
  // { path: '/dashboard', name: 'Dashboard', component: Dashboard },
  // { path: '/members', exact: true, name: 'Members', component: Members },
  // { path: '/tables', exact: true, name: 'Tables', component: Tables },
  // { path: '/players', exact: true, name: 'Players', component: Players },
  // { path: '/tournaments', exact: true, name: 'Tournaments', component: Tournaments },
  {
    path: "/categories",
    exact: true,
    name: "Categories",
    component: Categories,
  },
  { path: "/modes", exact: true, name: "Modes", component: Modes },
  {
    path: "/mode_family",
    exact: true,
    name: "ModeFamily",
    component: ModeFamily,
  },
  { path: "/games", exact: true, name: "Games", component: Games },
  { path: "/highlight", exact: true, name: "Highlight", component: Highlight },
  { path: "/templates", exact: true, name: "Templates", component: Templates },
  {
    path: "/itemcategories",
    exact: true,
    name: "ItemCategories",
    component: ItemCategories,
  },
  { path: "/items", exact: true, name: "Items", component: Items },
  {
    path: "/challenges",
    exact: true,
    name: "Challenges",
    component: Challenges,
  },
  {
    path: "/event/result",
    exact: true,
    name: "Result",
    component: Result,
  },

  // Development Module
  {
    path: "/development/budget",
    exact: true,
    name: "Budget",
    component: Budget,
  },
  {
    path: "/development/role",
    exact: true,
    name: "Role",
    component: Role,
  },
  {
    path: "/development/skill_type",
    exact: true,
    name: "SkillType",
    component: SkillType,
  },
  {
    path: "/development/skills",
    exact: true,
    name: "Skills",
    component: Skills,
  },
  {
    path: "/development/skill_type",
    exact: true,
    name: "SkillType",
    component: SkillType,
  },
  {
    path: "/development/developer",
    exact: true,
    name: "Developer",
    component: Developer,
  },
  {
    path: "/development/game_developer",
    exact: true,
    name: "Game Developer",
    component: GameDeveloper,
  },
  // Idea Launch Module
  {
    path: "/idea/whitelist",
    exact: true,
    name: "Whitelist Requests",
    component: Whitelist,
  },
  {
    path: "/platform/users",
    exact: true,
    name: "Users",
    component: Users,
  },
  {
    path: "/idea/force",
    exact: true,
    name: "Force Requests",
    component: Force,
  },
  {
    path: "/nft/hero",
    exact: true,
    name: "Hero",
    component: NftHeros,
  },
  {
    path: "/nft_drops",
    exact: true,
    name: "NFT DROP",
    component: NftDrop,
  },
  {
    path: "/nft/heros_batch",
    exact: true,
    name: "Heros Batch",
    component: NftHerosBatch,
  },
  {
    path: "/nft/variable_type",
    exact: true,
    name: "Variable Types",
    component: VariableType,
  },
  {
    path: "/nft/variable_items",
    exact: true,
    name: "Variable Items",
    component: VariableItems,
  },
  {
    path: "/nft/weapons",
    exact: true,
    name: "Weapons",
    component: Weapons,
  },
  {
    path: "/nft/rarity",
    exact: true,
    name: "Rarity",
    component: Rarity,
  },
  {
    path: "/nft/hero_actions",
    exact: true,
    name: "Hero Actions",
    component: NftSkills,
  },
];

export default routes;
